export class Album {
    id?: string
    name: string
    specialCollection: boolean
    manualAttachments?: {
        macroArea?: string
        storeId: string
        storeName?: string
        thumbnailURL?: string
        photoId: string
        status?: string
    }[] // manual photo selection to convert in string array
    filters: {
        macroRegions?: string[]
        countries?: string[]
        banners?: string[]
        storeIds?: string[]
        storeNames?: string[]
        segments?: string[]
        macroAreas?: string[]
        activityTypes?: { type: string; subType: string; label?: string }[]
        surveyPictures?: string[]
        from?: Date // to convert in number
        to?: Date // to convert in number
        selectedProjects?: '*' | { id: string; project_name: string }[] // to convert in projectIds: string array
        projectIds?: '*' | string[]
        pictureStatus?: string[]
    }

    distribution: {
        roles?: string[]
        stores: string[]
        people?: {
            userId: string
            firstname: string
            lastname: string
            nickname?: string
            attachment?: {
                url: string
            }
        }[]
    }

    constructor() {
        this.name = ''
        this.specialCollection = false
        this.filters = {}
        this.distribution = {
            stores: [],
        }
    }
}
